var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaestroColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2049_13699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.0009 14.9997C48.0009 23.1989 41.3674 29.8324 33.1683 29.8324C29.7073 29.8324 26.5348 28.6375 24.0215 26.6598C27.4824 23.9405 29.6661 19.7379 29.6661 14.9997C29.6661 10.2615 27.4412 6.05897 24.0215 3.33965C26.5348 1.36197 29.7073 0.167114 33.1683 0.167114C41.3674 0.167114 48.0009 6.84179 48.0009 14.9997Z",
    fill: "#0099DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0218 3.33899C24.0218 3.33899 24.0218 3.33899 24.0218 3.33899C27.4415 6.0583 29.6664 10.2609 29.6664 14.9991C29.6664 19.7373 27.4827 23.9399 24.0218 26.6592L23.9805 26.6592C20.5608 23.9811 18.3359 19.7373 18.3359 14.9992C18.3359 10.261 20.5608 6.05839 23.9806 3.33908C23.9805 3.33905 23.9806 3.33911 23.9806 3.33908L24.0218 3.33899Z",
    fill: "#6C6BBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3348 14.9997C18.3348 10.2615 20.5597 6.05897 23.9794 3.33965C21.4661 1.36197 18.2936 0.167114 14.8326 0.167114C6.63348 0.167114 0 6.80059 0 14.9997C0 23.1989 6.63348 29.8324 14.8326 29.8324C18.2936 29.8324 21.4661 28.6375 23.9794 26.6598C20.5597 23.9817 18.3348 19.7379 18.3348 14.9997Z",
    fill: "#EB001B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2049_13699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 29.6652,
    fill: "white",
    transform: "translate(0 0.167358)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaestroColor);
export default __webpack_public_path__ + "static/media/maestro-color.70a275d4c7955be6af826b0715a51ebe.svg";
export { ForwardRef as ReactComponent };